import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import Question from '@shared/types/question.type';
import { remove } from 'lodash';
import { flattenStyles } from '@angular/platform-browser/src/dom/dom_renderer';
/**
 * TODO:
 * This will need to be a wrapper around specific question types
 * Should probably implement ControlValueAccessor for use as a form control
 * https://coryrylan.com/blog/angular-custom-form-controls-with-reactive-forms-and-ngmodel
 */
@Component({
  selector: 'app-short-answer-question',
  templateUrl: './short-answer-question.component.html',
  styleUrls: ['./short-answer-question.component.scss'],
})
export class ShortAnswerQuestionComponent {
  public questionData: Question;
  public answer: any = '';
  public showChoices: boolean = false;
  public wrongInputType: boolean = false;
  private validAnswer;
  @Input() shortAnswer: any;
  @Input() user: string;

  @ViewChild('answerForm')
  answerForm: any;

  @Input()
  /**
   * TODO:
   * We probably shouldn't be resetting form in a question setter
   * however constructor isn't being called when question changes
   */
  set question(question: Question) {
    this.questionData = question;
    this.answerForm.nativeElement.reset();
  }
  get question(): Question {
    return this.questionData;
  }

  @Output() answerEvent = new EventEmitter<string>();
  @Output() dropDownEvent = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  setAnswer() {
    let emo = new RegExp(
      '(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c\ude32-\ude3a]|[\ud83c\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])'
    );
    if (typeof this.answer === 'string') {
      if (!this.answer.match(emo)) {
        this.sendAnswer(this.answer);
      } else {
        this.sendAnswer(null);
      }
    } else {
      this.sendAnswer(this.answer);
    }
  }

  setNumericAnswer() {
    this.checkValue();
    if (this.wrongInputType === false) {
      this.setAnswer();
    }
  }

  sendAnswer(answer) {
    this.answerEvent.emit(answer);
  }

  checkValue() {
    if (typeof this.answer === 'number') {
      this.wrongInputType = false;
    } else if (this.answer === null) {
      this.wrongInputType = true;
    } else if (this.answer === '') {
      this.wrongInputType = false;
    }
  }

  selected(event) {
    this.answer = event.detail.text;
    this.setAnswer();
    this.dropDownEvent.emit(this.answer);
  }
}
